import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* gameWrong({ payload }) {
  const {
    limit,
    stackSize,
    position,
    handType,
    id,
    option,
    category,
    game,
  } = payload;
  try {
    const res = yield call(api, {
      method: 'post',
      url: sessionStorage.getItem('isPlo5') === 'true' ? URL.GAME_WRONGPLO5 : URL.GAME_WRONG,
      data: {
        id,
        bb: stackSize.value,
        ts: limit.value,
        stake: position.replace('  ', ''),
        suit: handType.suit,
        pair: handType.pair,
        aces: !(!handType.pair && !handType.suit) || handType === 'random',
        option,
        category: category.toLowerCase().replace(' ', ''),
        game,
      },
    });
    if (!res?.data) return;
    yield put({ type: 'GAME_WRONG_SUCCESS', payload: res.data });
  } catch (e) {
    yield call(toast.error, e.message);
    yield put({ type: 'GAME_WRONG_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GAME_WRONG, gameWrong);
}
